module.exports = __webpack_public_path__ + "8cd6d84eec0f5aebfd3e83f925b9f0fe.pdf";